import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { FaSpinner } from "react-icons/fa";
import { MdPictureAsPdf } from "react-icons/md";
var ExportButton = function(param) {
    var isProcessing = param.isProcessing, token = param.token, progress = param.progress, exportReport = param.exportReport;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isProcessing && /*#__PURE__*/ _jsx("div", {
                children: "Preparing Report... This may take a few mins."
            }),
            /*#__PURE__*/ _jsx("button", {
                className: " bg-transparent border border-solid font-bold uppercase p-2 rounded outline-none",
                disabled: !token || isProcessing,
                onClick: exportReport,
                type: "button",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "mr-2",
                                    children: !token || isProcessing ? /*#__PURE__*/ _jsx(FaSpinner, {
                                        className: "animate-spin"
                                    }) : /*#__PURE__*/ _jsx(MdPictureAsPdf, {})
                                }),
                                "Export"
                            ]
                        }),
                        isProcessing && /*#__PURE__*/ _jsx("div", {
                            className: "overflow-hidden h-2 text-xs flex rounded bg-gray-500",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-primary",
                                style: {
                                    width: "".concat(progress, "%")
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export default ExportButton;
